<template>
    <section-layout class="section-about">
        <div class="section-about__content">
            <div class="d-flex flex-column flex-sm-row">
                <img src="@/assets/about-what.jpg" alt="" class="section-about__image col-sm-12" />
                <div class="col-sm-12 d-flex flex-column justify-content-center -pl-sm-5">
                    <div class="col-lg-19">
                        <p class="section-about__title heading-40 color-blue">Już po raz ósmy fundujemy stypendia!</p>
                        <p class="text-16">
                            W Enea Akademia Talentów, wspólnym projekcie Enei i Fundacji Enea – Energia Wspólnoty, już po raz ósmy wspieramy młodych ludzi z pasją. Przekazujemy im atrakcyjne stypendia, by mogli rozwijać umiejętności, zgłębiać wiedzę, zakupić potrzebny sprzęt i pomoce dydaktyczne. W tym roku mamy dla Was <span class="heading-16 color-blue">80 stypendiów po 5000 zł</span> w kategoriach: <span class="heading-16 color-blue"> nauki ścisłe, nauki przyrodnicze i inicjatywy społeczne.</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-column flex-column-reverse flex-sm-row">
                <div class="col-sm-12 d-flex flex-column justify-content-center -pe-sm-5">
                    <div class="col-lg-19">
                        <p class="section-about__title heading-40 color-blue">Aż 400 000 zł dla młodych talentów!</p>
                        <p class="text-16">
                            Wiemy, że każdy talent potrzebuje wsparcia, by mógł się w pełni rozwinąć. Dlatego Enea i Fundacja Enea – Energia Wspólnoty już po raz drugi przeznaczą aż 400 000 zł na stypendia dla utalentowanych młodych ludzi. Środki te pokryją koszty m.in. wyjazdów edukacyjnych, udziału w wydarzeniach naukowych, konkursach i olimpiadach, zakupu książek, pomocy dydaktycznych, sprzętu.
                        </p>
                    </div>
                </div>
                <div class="col-sm-12 d-flex flex-column justify-content-center -pl-sm-5">
                    <div class="section-about__image-wrap">
                        <img src="@/assets/about-who.jpg" alt="" class="section-about__image w-100" />
                    </div>
                    <p class="section-about__ai-note mt-1 mt-sm-3">Materiał został wygenerowany przy użyciu AI.</p>
                </div>
            </div>

            <div class="d-flex flex-column flex-sm-row">
                <img src="@/assets/about-how-2.jpg" alt="" class="section-about__image col-sm-12" />
                <div class="col-sm-12 d-flex flex-column justify-content-center -pl-sm-5">
                    <div class="col-lg-19">
                        <p class="section-about__title heading-40 color-blue">Poszukiwane, poszukiwani!</p>
                        <p class="text-16 mb-2">
                            Do konkursu zapraszamy uczennice i uczniów ze szkół podstawowych (klasy 6-8) oraz ponadpodstawowych z całej Polski! Zgłoś się do sekcji, która jest najbliższa Twoim zainteresowaniom, i walcz o stypendium w wysokości 5000 zł.
                        </p>

                        <p class="text-16">Nie czekaj, wyślij zgłoszenie do 31 października!</p>
                    </div>
                </div>
            </div>

        </div>

    </section-layout>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
    },
    components: {
    },
    computed: {
    },
};
</script>
